var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoResearchPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 6L32 30L22 28L14 32L4 30L4 6L14 8L22 4L32 6Z",
    fill: "#2DCDAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoResearchPlan);
export default __webpack_public_path__ + "static/media/Ico_ Research Plan.98610ea0d6e389c13469b96e24a5f0d9.svg";
export { ForwardRef as ReactComponent };